import { FC, useMemo } from 'react'
import * as styles from 'components/features/pfm/TransactionCategory/TransactionCategoryOption.styl'
import { TypedMoneyflowCategory } from 'interfaces/meta'
import cn from 'classnames'
import { ALL_CATEGORY_ID } from 'constants/meta'
import SvgIcon from 'components/atoms/SvgIcon'
import { WrappedFieldProps } from 'redux-form'
import { State } from 'interfaces/state'

type TransactionCategoryOptionWrappedProps =
  & WrappedFieldProps<State>
  & {
    category: TypedMoneyflowCategory
  }


export const TransactionCategoryOptionWrapped: FC<TransactionCategoryOptionWrappedProps> = (props) => {
  const {
    meta,
    input,
    ...restProps
  } = props


  const { id, type, value } = restProps.category

  const theme = useMemo(() => {
    if (type === 'spending') {
      return 'blue'
    } else if (type === 'income') {
      return 'green'
    } else {
      return 'gray'
    }
  }, [type])

  const labelClassName = useMemo(() => cn(styles.label, {
    [styles[theme]]: true,
  }), [theme])

  const iconChild = useMemo(() => {
    let iconKind = id
    if (id === ALL_CATEGORY_ID) {
      iconKind = type === 'spending' ? 'spending' : 'income'
    }
    const iconSource = require(`icons/${ iconKind }.svg`).default

    return <SvgIcon src={ iconSource } />
  }, [id, type])

  const inputId = `transaction-recat_${ id }`

  if (!input) {
    return null
  }

  return (
    <div className={ styles.transactionCategory }>
      <input
        id={ inputId }
        data-qa-type='radio'
        data-qa-marker={ inputId }
        className={ styles.radioInput }
        checked={ input.checked }
        type='radio'
        { ...input }
      />
      <label data-qa-type='label' htmlFor={ inputId } className={ labelClassName }>
        <div>
          <i className={ styles.icon }>
            { iconChild }
          </i>
          <span>{ value }</span>
        </div>
      </label>
    </div>
  )
}
